export const HEADER_CSS_CLASS = 'js-default-layout-header';
// In pixels
export const SCROLL_TO_OFFSET = 10;
